import { render, staticRenderFns } from "./EditContractDetails.vue?vue&type=template&id=84fd202e&scoped=true"
import script from "./EditContractDetails.vue?vue&type=script&lang=js"
export * from "./EditContractDetails.vue?vue&type=script&lang=js"
import style0 from "./EditContractDetails.vue?vue&type=style&index=0&id=84fd202e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fd202e",
  null
  
)

export default component.exports